/**
 * A graft webservice configured as a bare path (e.g. `/graft-ws/regusers`) is relayed
 * by the portal's own server instead of being dialled directly by the browser.
 */
export function isSameOriginGraftPath(value: string | undefined): value is string {
  return Boolean(value?.startsWith('/'))
}
